<template>
  <div class="frees-container">
    <div class="select-modal" v-show="show">
      <div class="modal">
        <div class="btn man" @click="selectBtn(1)">
          <span>我是男生</span>
          <img src="../../assets/image/advert/btn2.png" alt="">
        </div>
        <div class="btn woman" @click="selectBtn(2)">
          <span>我是女生</span>
          <img src="../../assets/image/advert/btn2.png" alt="">
        </div>
      </div>
    </div>
    <img class="bg" src="../../assets/image/advert/bg.jpg" alt="">
    <div class="qrcode" v-if="!isIos">
      <img v-if="tag==1" src="../../assets/image/advert/man-qrcode.png" alt="">
      <img v-if="tag==2" src="../../assets/image/advert/woman-qrcode.png" alt="">
    </div>
    <div class="copy-area" v-else>
      <div class="copy" @click="copy">
        点击复制默往号 <br> 添加客服
      </div>
      <div class="tip">点击消息首页-点击右上方加号-点击添加好友</div>
      <img src="../../assets/image/advert/btn1.png" alt="">
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { Toast } from 'vant'

export default {
  name: 'Fress',
  data () {
    return {
      show: true,
      tag: 1,
      isIos: false
    }
  },
  created () {
    document.title = 'FREES 高端私密社交'
    var u = window.navigator.userAgent
    this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  methods: {
    selectBtn (tag) {
      this.tag = tag
      this.show = false
    },
    copy (event) {
      const clipboard = new Clipboard(event.target, {
        text: () => this.tag == 1 ? 'frees007' : 'frees333'
      })
      clipboard.on('success', () => {
        Toast('复制成功，请去消息首页添加客服默往号')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        alert('复制失败')
        clipboard.destroy()
      })
      clipboard.onClick(event)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/css/style.scss";

  .frees-container {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    font-size: 0;
    position: relative;

    .bg {
      width: 100%;
    }

    .select-modal {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background: #000;

      .modal {
        /*width: px2rem(600);*/
        width: 100%;
        height: px2rem(500);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: url("../../assets/image/advert/small-bg.jpg");
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;

        .btn {
          position: relative;

          img {
            width: px2rem(500);
          }

          span {
            position: absolute;
            font-weight: bold;
            color: #fff;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -90%);
            font-size: px2rem(58);
            letter-spacing: px2rem(4);
          }
        }
      }
    }

    .qrcode {
      position: absolute;
      top: px2rem(3250);
      left: 50%;
      transform: translateX(-50%);

      img {
        width: px2rem(400);
      }
    }

    .copy-area {
      position: absolute;
      top: px2rem(3350);
      left: 50%;
      transform: translateX(-50%);

      img {
        width: px2rem(600);
      }

      .copy {
        position: absolute;
        width: 100%;
        text-align: center;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -65%);
        font-size: px2rem(48);
        color: #624527;
        font-weight: bold;
      }

      .tip{
        width: 100%;
        position: absolute;
        bottom: px2rem(-24);
        text-align: center;
        font-size: px2rem(24);
        color: #fff;
      }
    }
  }
</style>
